module.exports = __webpack_public_path__ + "img/sideflag.fbc70ad.svg";